import { Badge, BadgeColor } from "@prequel/shared-components";

import { TransferStatus } from "./helpers";

export { getModelDisplayStatus, summarizeTransferModels, TransferStatus } from "./helpers";

export const TransferStatusLabel: Record<TransferStatus, string> = {
  [TransferStatus.CANCELLED]: "Cancelled",
  [TransferStatus.ERROR]: "Error",
  [TransferStatus.EXPIRED]: "Expired",
  [TransferStatus.PARTIAL_FAILURE]: "Partial Failure",
  [TransferStatus.PENDING]: "Pending",
  [TransferStatus.RUNNING]: "Running",
  [TransferStatus.SUCCESS]: "Success",
  [TransferStatus.KILLED]: "Killed",
  [TransferStatus.ORPHANED]: "Orphaned",
};

export const getTransferStatusBadgeColor = (status: TransferStatus): BadgeColor => {
  switch (status) {
    case TransferStatus.ERROR:
      return BadgeColor.RED;
    case TransferStatus.PENDING:
      return BadgeColor.ORANGE;
    case TransferStatus.CANCELLED:
    case TransferStatus.ORPHANED:
    case TransferStatus.EXPIRED:
    case TransferStatus.KILLED:
      return BadgeColor.GRAY;
    case TransferStatus.RUNNING:
      return BadgeColor.BLUE;
    case TransferStatus.SUCCESS:
      return BadgeColor.GREEN;
    default:
      return BadgeColor.GRAY;
  }
};

export const isTransferStatusBadgeActive = (status: TransferStatus): boolean => {
  return [TransferStatus.RUNNING, TransferStatus.PENDING, TransferStatus.ERROR, TransferStatus.SUCCESS].includes(
    status,
  );
};

interface TransferStatusBadgeProps {
  status: TransferStatus;
  color?: BadgeColor;
  isActive?: boolean;
}

const TransferStatusBadge = ({
  status,
  color = getTransferStatusBadgeColor(status),
  isActive = isTransferStatusBadgeActive(status),
}: TransferStatusBadgeProps) => {
  return <Badge className="normal-case" color={color} active={isActive} text={status} />;
};

export default TransferStatusBadge;
